"use client";

import { useState, useEffect, useCallback } from "react";
import { api } from "@/lib/api";
import type { AuthState } from "@/types/analysis";

interface UseAuthReturn {
  /** 인증 상태 */
  auth: AuthState | null;
  /** 로딩 중 여부 */
  loading: boolean;
  /** 인증 상태 새로고침 */
  refresh: () => Promise<void>;
  /** 로그인 필요 여부 (auth 로드 완료 + 미로그인) */
  needsLogin: boolean;
}

/**
 * 인증 상태 관리 훅
 * 서버의 GET /api/me 엔드포인트에서 사용자 정보 조회
 */
export function useAuth(): UseAuthReturn {
  const [auth, setAuth] = useState<AuthState | null>(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const data = await api<AuthState>("/api/me");
      setAuth(data);
      if(data.loggedIn && typeof window!=='undefined' && (location.pathname==='/bite'||location.pathname.startsWith('/bite/')||location.pathname==='/'&&/^(www\.)?bite\.cx$/.test(location.hostname))) {
        void import('@/lib/bite-login-measurement').then(m=>m.completeBiteLoginMeasurement()).catch(()=>{});
      }
    } catch {
      setAuth({ loggedIn: false });
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const needsLogin = !loading && (auth === null || !auth.loggedIn);

  return { auth, loading, refresh, needsLogin };
}
